import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_FLEET_PLANNING_URL

export const get = async (queryParams = {}) => {
  const params = {
    latitude: queryParams?.latitude,
    longitude: queryParams?.longitude,
    search: queryParams?.search || undefined,
    available: queryParams?.filterButton,
    user_group_id: queryParams?.user_group_id || undefined,
    box_type_id: queryParams?.box_type_id || undefined,
    vehicle_category: queryParams?.vehicle_category || undefined,
    product_category_id: queryParams?.product_category_id || undefined,
    vehicle_type_id: queryParams?.vehicle_type_id || undefined,
    customer_id: queryParams?.customer_id || undefined,
    contract_type: queryParams?.contract_type || undefined,
  }

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/nearest-vehicle',
    params,
  })

  return response?.data
}
